export const DROP_PIN_CURSOR_SIZE_PX = 36;
/** Cursor tip sits on the icon head while dragging. */
export const DROP_PIN_CURSOR_HOTSPOT_Y_PX = 8;
export const DROP_PIN_RETURN_MIN_MS = 280;
export const DROP_PIN_RETURN_MAX_MS = 520;
export const DROP_PIN_RETURN_MS_PER_PX = 0.38;

export type DropPinCursorPhase =
  | 'dragging'
  | 'awaiting-land'
  | 'returning';

export type DropPinDragEndAction = 'land' | 'return';

export type DropPinLandingApi = {
  /** Failed / cancelled drop — clear ghost and restore the source button icon. */
  readonly abortLanding: () => void;
  /**
   * Successful handoff to the map fall overlay — hide the drag ghost without
   * playing return-home, and keep the source button icon hidden.
   */
  readonly suppressForMapFall: () => void;
  /** After a successful map drop — put the source button icon back in place (no fly-back). */
  readonly releaseSource: () => void;
};

export function resolveDropPinDragEndAction(
  droppedOnValidTarget: boolean,
): DropPinDragEndAction {
  return droppedOnValidTarget ? 'land' : 'return';
}

export function resolveDropPinReturnDurationMs(
  distancePx: number,
  prefersReducedMotion: boolean,
): number {
  if (prefersReducedMotion) {
    return 1;
  }
  const safeDistance = Number.isFinite(distancePx) ? Math.max(0, distancePx) : 0;
  return Math.round(
    Math.min(
      DROP_PIN_RETURN_MAX_MS,
      Math.max(DROP_PIN_RETURN_MIN_MS, safeDistance * DROP_PIN_RETURN_MS_PER_PX),
    ),
  );
}

export function buildDropPinCursorTransform(
  clientX: number,
  clientY: number,
): string {
  const half = DROP_PIN_CURSOR_SIZE_PX / 2;
  return `translate3d(${clientX - half}px, ${clientY - DROP_PIN_CURSOR_HOTSPOT_Y_PX}px, 0)`;
}

export function resolveDropPinIconClassName(
  phase: DropPinCursorPhase | null,
): string {
  if (phase === 'dragging') {
    return 'slp-drop-pin-drag-cursor__icon slp-drop-pin-drag-cursor__icon--swing';
  }
  return 'slp-drop-pin-drag-cursor__icon';
}

export function resolveDropPinReturnEndScale(sourceWidthPx: number): number {
  return Math.max(0.5, sourceWidthPx / DROP_PIN_CURSOR_SIZE_PX);
}
